import React, { Fragment } from 'react';
import GoogleStudioDashboard from './GoogleStudioDashboard';
import ScreenTimeTrack from "Components/Common/ScreenTimeTrack/index";
import { gDashboardReportIdMapping } from 'Constants/screenInfoDetailsConstants';
const GDashboard = (props) => {
    const { match } = props;
    const reportId = (match.params || {}).reportId;
    return (
        <Fragment>
            <ScreenTimeTrack
                screenInfoDetailsItem={
                    gDashboardReportIdMapping[reportId] || {}
                }
            />
            <GoogleStudioDashboard
                report_id = {reportId}
            />
        </Fragment>
    )
}

export default GDashboard;